import axios from '@/libs/api.request'

export const getEvaluationsinfolist = (page, limit, key, value) => {
  return axios.request({
    url: '/v1/evaluationsinfo/evaluationsinfo/',
    method: 'get',
    params: {
      key,
      value,
      page,
      limit
    }
  })
}

export const operationEvaluationsinfo = (data, meth) => {
  return axios.request({
    url: '/v1/evaluationsinfo/evaluationsinfo/',
    method: meth,
    data
  })
}